import PricingTable from './PricingTable';

export default PricingTable;
